import { render } from "./MdListDetailPage.vue?vue&type=template&id=0bfd1cfc&scoped=true"
import script from "./MdListDetailPage.vue?vue&type=script&lang=js"
export * from "./MdListDetailPage.vue?vue&type=script&lang=js"

import "./MdListDetailPage.vue?vue&type=style&index=0&id=0bfd1cfc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bfd1cfc"]])

export default __exports__